const mutations = {
  setUser: (state, data) => {
    state.userName = data.nickname;
    state.avatarURL = data.avatarURL;
    state.xyLevel = data.xyLevel;
  },
  setToast: (state, toast) => {
    state.toast = toast;
  },
  addPreRequest(state, { key, rsp, source }) {
    state.preRequests = {
      ...state.preRequests,
      [key]: {
        rsp,
        source,
      },
    };
  },
};

export default mutations;
